// extracted by mini-css-extract-plugin
export default {"earlyAccessLabel":"uMvbK","access-purchase":"GD6dm","access-view":"Dgir5"};